import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import ReduxFormsField from '../common/forms/ReduxFormsField';


class ChangeEmailForm extends Component {
  static propTypes = {
    ...formPropTypes,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    error: PropTypes.object,
  };

  render() {
    const { handleSubmit, onCancel, submitting } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <div className="modal__content">
          <h3>Change Email</h3>
          <Field
            name="email"
            component={ReduxFormsField}
            label="New Email"
            required={true}
          >
            <input type="email" />
          </Field>
        </div>
        <div className="modal__actions">
          <div className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
            Cancel
          </div>
          <button type="submit" className="button" disabled={submitting}>
            Submit
          </button>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'changeEmailForm'
})(ChangeEmailForm);



// WEBPACK FOOTER //
// ./src/users/ChangeEmailForm.js